(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recomm-related"] && !window.DesignMode) return;
  try {
    
  function openTabs(evt, TabName) {
    // Declare all variables
    var i, tabcontent, tablinks;
  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
  
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
  
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(TabName).style.display = "block";
    evt.currentTarget.className += " active";  
  }
    
  // Get the element with id="defaultOpen" and click on it
  document.getElementById("defaultOpen").click();
  $("#defaultOpen").on('click', function(event){
    $(".product-tab-slider").css({"height": $(".product-tab-slider").outerHeight()});
    openTabs(event, 'tab1')
  })
  $("#defaultOpen2").on('click', function(event){
    $(".product-tab-slider").css({"height": $(".product-tab-slider").outerHeight()});
    openTabs(event, 'tab2')
  })

  } catch(e) { console.error(e); }
})();
})();
